import {
  Button,
  Card,
  Col,
  EditButton,
  Icons,
  ListButton,
  Popconfirm,
  Row,
  Show,
  Tag,
  Typography,
  notification,
} from '@pankod/refine-antd';
import { useNavigation } from '@pankod/refine-core';
import { useParams } from '@pankod/refine-react-router-v6';
import { ETemplateAttributeType } from 'enums';
import { useEffect, useState } from 'react';
import { ITemplate, deleteTemplate, getTemplate } from 'services/template';
import { capitalize } from 'utilities/shared';

const { Text, Title } = Typography;

export const TemplateShow: React.FC = () => {
  const [template, setTemplate] = useState<ITemplate | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();
  const { list } = useNavigation();

  const fetchData = async (id: string) => {
    try {
      setIsLoading(true);
      const response = await getTemplate(id);
      setTemplate(response);
    } catch (err: any) {
      console.error(err.message);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchData(id);
  }, [id]);

  const headerButtons = (
    <>
      <ListButton />
      <EditButton />
      <Popconfirm
        title="Are you sure?"
        okText="Delete"
        onConfirm={async () => {
          if (!id) return;

          await deleteTemplate(id);
          notification.success({
            message: 'Success',
            description: 'Deleted successfully',
          });
          list('products/templates');
        }}
      >
        <Button size="middle" danger icon={<Icons.DeleteOutlined />}>
          Delete
        </Button>
      </Popconfirm>
    </>
  );

  return (
    <>
      <Show headerButtons={headerButtons}>
        <Row gutter={[0, 32]} justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Card loading={isLoading} title="Information">
              <Title level={5}>Name</Title>
              <Text>{template?.name}</Text>
              <Title level={5}>Description</Title>
              <Text>{template?.description}</Text>
            </Card>
          </Col>
        </Row>
      </Show>

      {/* Attributes */}
      <Card loading={isLoading} title={<Text>Attributes</Text>} style={{ marginTop: '1rem' }}>
        <Row>
          <Col span={12} offset={6}>
            {template?.productAttribute.map((attribute) => {
              const attributeCardTitle = <Text>{capitalize(attribute.name)}</Text>;

              return (
                <Card
                  key={attribute.id}
                  title={attributeCardTitle}
                  style={{ flex: 1, marginBottom: '20px' }}
                >
                  <Title level={5}>Type:</Title>
                  <Text>{ETemplateAttributeType[attribute.type]}</Text>

                  <Title level={5}>Required:</Title>
                  <Text>{attribute.required ? 'true' : 'false'}</Text>

                  {attribute.type === 'dropdown' && (
                    <>
                      <Title level={5}>Allow Custom Value:</Title>
                      <Text>{attribute.allowCustomValue ? 'true' : 'false'}</Text>
                    </>
                  )}

                  {attribute.type === 'dropdown' && (
                    <>
                      <Title level={5}>Options:</Title>
                      <Text>
                        {attribute.options.map((option, index) => (
                          <Tag key={index}>{option}</Tag>
                        ))}
                      </Text>
                    </>
                  )}
                </Card>
              );
            })}
          </Col>
        </Row>
      </Card>
    </>
  );
};
